// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xekajxxachrhziuykkdj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhla2FqeHhhY2hyaHppdXlra2RqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUyODk4MzYsImV4cCI6MjA1MDg2NTgzNn0.OX11gyWcO1f9bPX4Y3qNxdrZ5DpQoq34swJ0FJ6aeqo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);